<template>
  <div class="steps-wrap">
    <div v-for="(item, index) in steps" 
        :key="index" 
        :class="['step-item', {
            'step-current': index === active,
            'step-done': index < active
        }]" 
        @click="onStep(index)"
    >
        <span>Step{{index+1}}:{{ item.title}}</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang("@shining3d/xl-design-order");

const emits = defineEmits(['click']);

const props = defineProps({
    active: {
        type: Number,
        default: 0
    },
    steps: {
        type: Object,
        default: () => ([])
    }
});

const onStep = (index) => {
    emits('click', index);
};

</script>

<style lang="scss" scoped>
.steps-wrap {
    width: 100%;
    background: #fff;
    display: flex;
    .step-item {
        height: 38px;
        flex: 1;
        background: #F2F3F7;
        clip-path: polygon(calc(100% - 10px) 0%, 100% 50%, calc(100% - 10px) 100%, 0% 100%, 10px 50%, 0% 0%);
        font-size: 14px;
        color: #42526E;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-family: $font-family65;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        &:first-child {
            clip-path: polygon(calc(100% - 10px) 0%, 100% 50%, calc(100% - 10px) 100%, 0% 100%, 0px 50%, 0% 0%);
        }
        span {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 15px;
            box-sizing: border-box;
            text-align: center;
        }
    }
    .step-current {
        background: #5587FF;
        color: #fff;
    }
    .step-done {
        background: #EDF3FF;
        color: #5587FF;
    }
}
</style>